const selector = '.exchanges-rate-btc24h-wrapper';

const initWidget = async () => {
    if (!document.querySelector(selector)) {
        return;
    }

    const { default: exchangesRateBtc24h } = await import('../widgets/exchangesRateBtc24h.js');
    await exchangesRateBtc24h.updateDynamicsData();
};

(function ($) {
    $(function () {
        window.$ = jQuery;

        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(initWidget, { timeout: 1500 });
        } else {
            window.addEventListener('load', () => {
                setTimeout(initWidget, 0);
            }, { once: true });
        }
    });
}(jQuery));
